import React, { CSSProperties } from 'react';

import { Status } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';

import { IssueStatus } from './atoms/IssueStatus';

type Props = {
  issueKey: string;
  summary: string;
  icon: string;
  isClosed?: boolean;
  status?: Status;
  textStyle?: CSSProperties;
  justifyContent?: string;
};

export default function IssueRowComponent({
  issueKey,
  summary,
  icon,
  isClosed,
  status,
  textStyle,
  justifyContent = 'space-between',
}: Props): JSX.Element {
  const strikethrough: Pick<CSSProperties, 'textDecoration'> = {
    textDecoration: isClosed ? 'line-through' : '',
  };

  return (
    <div
      className='issue-row-component-wrapper'
      style={{
        justifyContent,
      }}
      onClick={async () =>
        window.open(
          await StorageOfUniqueServices.get('URLService').getIssueURL(issueKey)
        )
      }
    >
      <div className='issue-row-component-key-summary-wrapper'>
        <div className='issue-row-component-key-wrapper'>
          <img alt='' src={icon} className='issue-row-component-icon' />
          <span className='issue-row-component-key' style={strikethrough}>
            {issueKey}
          </span>
        </div>
        <span className='text-wrapper' style={textStyle}>
          {summary}
        </span>
      </div>
      {status && (
        <div className='issue-row-component-status-wrapper'>
          <IssueStatus kind={status.kind}>{status.name}</IssueStatus>
        </div>
      )}
    </div>
  );
}
